module.exports = __webpack_public_path__ + "static/gin-1-b9eb41acb045f069192d820da717e9d3.jpg";